import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './TermsOfService.css';

const TermsOfService = ({ onClose }) => {
  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal">
        <div className="terms-modal-header">
          <h2>Terms of Service</h2>
          <button className="terms-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="terms-modal-content">
          <h3>1. Acceptance of Terms</h3>
          <p>
            By accessing or using the Student Helper platform, you agree to be bound by these Terms of Service. 
            If you do not agree to these terms, please do not use the platform.
          </p>

          <h3>2. User Accounts</h3>
          <p>
            2.1. To use certain features of the platform, you must register for an account.<br />
            2.2. You are responsible for maintaining the confidentiality of your account information.<br />
            2.3. You are responsible for all activities that occur under your account.
          </p>

          <h3>3. User Content</h3>
          <p>
            3.1. You retain ownership of any content you submit to the platform.<br />
            3.2. By submitting content, you grant Student Helper a worldwide, non-exclusive license to use, 
            reproduce, modify, and display your content for the purpose of operating the platform.<br />
            3.3. You agree not to submit any content that is illegal, offensive, or violates the rights of others.
          </p>

          <h3>4. Academic Integrity</h3>
          <p>
            4.1. Student Helper is designed to assist with learning and should not be used to engage in academic dishonesty.<br />
            4.2. Users are expected to comply with their educational institution's academic integrity policies.<br />
            4.3. Plagiarism and cheating are strictly prohibited.
          </p>

          <h3>5. Privacy Policy</h3>
          <p>
            Your use of the platform is also governed by our Privacy Policy, which outlines how we collect, 
            use, and protect your personal information.
          </p>

          <h3>6. Prohibited Activities</h3>
          <p>You agree not to:</p>
          <ul>
            <li>Use the platform for any illegal purpose</li>
            <li>Impersonate others or provide inaccurate information</li>
            <li>Attempt to gain unauthorized access to the platform or others' accounts</li>
            <li>Use the platform to transmit malware or harmful code</li>
            <li>Interfere with the proper functioning of the platform</li>
          </ul>

          <h3>7. Termination</h3>
          <p>
            We reserve the right to suspend or terminate your account for violations of these Terms of Service.
          </p>

          <h3>8. Limitation of Liability</h3>
          <p>
            Student Helper is provided "as is" without warranties of any kind. We are not liable for any damages 
            arising from your use of the platform.
          </p>

          <h3>9. Changes to Terms</h3>
          <p>
            We may modify these terms at any time. Continued use of the platform after changes 
            constitutes acceptance of the modified terms.
          </p>

          <h3>10. Contact Information</h3>
          <p>
            If you have questions about these Terms of Service, please contact us at support@student-helper.com መልካም እድል
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 